import { useSearchParams } from 'libs/router'
import { getCurrentQuery } from 'utils/getCurrentQuery'

export const useFilter = () => {
	const [, setSearchParams] = useSearchParams()

	const handleFilter = ({ id, value }: { id: string; value: string | null }) => {
		const query = getCurrentQuery()
		const newParams = new URLSearchParams(query)

		if (value) {
			newParams.set(id, value)
		} else {
			newParams.delete(id)
		}

		newParams.delete('cursor')
		setSearchParams(newParams)
	}

	return { handleFilter }
}
